import React, { useContext, useEffect, useState } from "react";
import {
  Form,
  Space,
  Col,
  Row,
  Modal,
  Typography,
  Checkbox,
  Button,
} from "antd";
import { SearchOutlined } from "@ant-design/icons";
import { Link, useLocation, Redirect } from "react-router-dom";
import {
  BlankSpace,
  PageContainer,
  Xpagination,
} from "../../../component/Xcomponent";
import { connect } from "react-redux";
import _ from "lodash";
// action
import {
  getTestBookList,
  getTestBookListResetState,
} from "../../../action/getTestBookListAction";
import {
  DetailSpan,
  InputBox,
  PatientCard,
  XButton,
  LabelSpan,
} from "./TestBookListStyle";
import {
  getCommonMasterList,
  getCommonMasterListReset,
} from "../../../action/getCommonMasterListAction";
import HeaderContext from "../../../context/HeaderContext";

import { getTestCategories } from "../../../action/getTestCategoriesAction";

const TestbookList = (props) => {
  const {
    getTestBookList,
    getTestBookListState,
    getTestBookListResetState,
    getCommonMasterList,
    getCommonMasterListReset,
    getCommonMasterListState,
    getTestCategories,
    getTestCategoriesState,
  } = props;
  const [form] = Form.useForm();

  const { Title } = Typography;
  // drawer

  const [redirect, setRedirect] = useState([false, ""]);
  const search = useLocation().search;
  const [category, setCategory] = useState();
  const [isModalVisible, setIsModalVisible] = useState(false);
  const page = new URLSearchParams(search).get("page");
  //pagination
  const [pagination, setPagination] = useState({
    page: page ? page : 1,
    records: 20,
  });

  const initialSearchData = {
    search_contain: "",
    categories: null,
  };
  const [searchData, setSearchData] = useState(initialSearchData);
  const { setTitle } = useContext(HeaderContext);
  setTitle("Test Directory");

  //callback
  useEffect(() => {
    return () => {
      getTestBookListResetState();
    };
  }, []);

  // Callbacks
  useEffect(() => {
    console.log("searchData=>", searchData);
    getTestBookList({
      // page: pagination.page,
      // records: pagination.records,
      ...searchData,
      ...pagination,
    });
  }, [pagination]);

  //pagination
  // useEffect(() => {
  //   setRedirect([true, `/test-book?page=${pagination.page}`]);
  // }, [pagination]);

  useEffect(() => {
    // getCommonMasterList({
    //   slug: "category_for_test_directory",
    // });
    // return () => {
    //   getCommonMasterListReset();
    // };

    getTestCategories();
  }, []);
  // Functions

  //handle search input
  const handleOnChange = (e) => {
    setSearchData({ ...searchData, [e.target.name]: e.target.value });
    getTestBookList(searchData);
  };

  //clear filters
  const handleReset = () => {
    form.resetFields();
    setSearchData(initialSearchData);
    setPagination({ ...pagination, ["page"]: 1 });
  };

  //searchfilters
  const searchPatient = () => {
    setPagination({ ...pagination, ["page"]: 1 });
  };

  const showModal = () => {
    setIsModalVisible(true);

    setCategory();
  };
  function closeModal() {
    setIsModalVisible(false);
  }
  const handleOk = () => {};
  const onChangeCat = (checkedValues) => {
    setCategory(checkedValues);
    console.log("category", category);
  };
  const searchfiler = async () => {
    setIsModalVisible(false);
    let searchDt = {
      ...searchData,
      ...pagination,
      categories: category?.join(","),
    };
    // setSearchData({ ...searchData, ["categories"]:  category.join(',')});
    // console.log("searchData", searchData);
    // getTestBookList({
    //   page: pagination.page,
    //   records: pagination.records,
    //   ...searchData,
    // });
    setSearchData(searchDt);
    getTestBookList(searchDt);
  };
  return (
    <>
      {redirect[0] && <Redirect to={redirect[1]} />}
      <PageContainer>
        <Form form={form} onFinish={searchPatient} layout="vertical">
          {/*<Row gutter={24}>*/}
          {/*    <Col xs={24} sm={24} md={12} lg={8} xl={8}>*/}
          {/*        <Form.Item*/}
          {/*            name="search_contain"*/}
          {/*        >*/}
          {/*            <InputBox type="text" name="search_contain" size="large" onChange={handleOnChange} placeholder="Search by Lilac ID, test name, display test name, keywords or aliases" prefix={<SearchOutlined style={{ color: "#7e7b7b9c" }} />} />*/}
          {/*        </Form.Item>*/}
          {/*    </Col>*/}
          {/*    <Col xs={24} sm={24} md={12} lg={6} xl={4}>*/}
          {/*        <Space>*/}
          {/*            <Form.Item name="search_btn">*/}
          {/*                <XButton*/}
          {/*                    className="search_btn"*/}
          {/*                    size="large"*/}
          {/*                    type="primary"*/}
          {/*                    htmlType="submit"*/}
          {/*                >*/}
          {/*                    Search*/}
          {/*                </XButton>*/}
          {/*            </Form.Item>*/}
          {/*            <Form.Item name="reset_btn">*/}
          {/*                <XButton*/}
          {/*                    type="primary"*/}
          {/*                    ghost*/}
          {/*                    onClick={() => handleReset()}*/}
          {/*                    size="large"*/}
          {/*                    style={{ width: 100 }}*/}
          {/*                >*/}
          {/*                    Reset*/}
          {/*                </XButton>*/}
          {/*            </Form.Item>*/}
          {/*        </Space>*/}
          {/*    </Col>*/}
          {/*</Row>*/}
        </Form>
        <div className="row mb-4">
          <div className="col-10 col-sm-6 col-lg-4">
            <InputBox
              type="text"
              name="search_contain"
              onChange={handleOnChange}
              placeholder="Search by test name"
              prefix={<SearchOutlined style={{ color: "#7e7b7b9c" }} />}
            />
          </div>
          <div className="col-2 col-sm-1 col-lg-1">
            <img
              className="img-fluid"
              onClick={showModal}
              src="/images/svg/Filter.svg"
              alt="logo"
            />
          </div>
        </div>
        {getTestBookListState.list.length > 0 ? (
          <>
            <Row gutter={[20, 20]}>
              {getTestBookListState.list.map((item) => (
                <Col xs={24} sm={24} md={12} lg={12} xl={8}>
                  <PatientCard title={`${item.display_test_name}`}>
                    {item.keywords_or_aliases && (
                      <p
                        style={{
                          width: "100%",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          display: "-webkit-box",
                          WebkitBoxOrient: "vertical",
                          WebkitLineClamp: 2,
                        }}
                      >
                        <LabelSpan>Also Known as :</LabelSpan>
                        <DetailSpan>
                          {item.keywords_or_aliases
                            ? item.keywords_or_aliases
                            : "NA"}
                        </DetailSpan>
                      </p>
                    )}
                    {item.tat && (
                      <p>
                        <LabelSpan>TAT : </LabelSpan>
                        <DetailSpan>{item.tat} hrs</DetailSpan>
                      </p>
                    )}
                    {item.sample.length > 0 && (
                      <>
                        {item.sample[0].sample_type && (
                          <p>
                            <LabelSpan>Sample : </LabelSpan>
                            <DetailSpan>
                              {item.sample[0].sample_type}
                            </DetailSpan>
                          </p>
                        )}
                        {item.sample[0].sample_transport_condition && (
                          <p>
                            <LabelSpan>Transport Condition : </LabelSpan>
                            <DetailSpan>
                              {
                                item.sample[0].sample_transport_condition.split(
                                  " "
                                )[0]
                              }{" "}
                              &nbsp;
                              {
                                item.sample[0].sample_transport_condition.split(
                                  " "
                                )[0].includes("-")
                               ? (
                                <>
                                  &deg;
                                  {
                                    item.sample[0].sample_transport_condition.split(
                                      " "
                                    )[1]
                                  }
                                </>
                              ) : (
                                item.sample[0].sample_transport_condition.split(
                                  " "
                                )[1]
                              )}
                            </DetailSpan>
                          </p>
                        )}
                      </>
                    )}
                    {item.container.length > 0 && (
                      <>
                        {item.container[0].display_container_name && (
                          <p>
                            <LabelSpan>Container : </LabelSpan>
                            <DetailSpan>
                              {item.container[0].display_container_name}
                            </DetailSpan>
                          </p>
                        )}
                      </>
                    )}

                    {/* <p>
                      <LabelSpan>Category For Test Directory : </LabelSpan>
                      <DetailSpan>
                        {item.test_id?.category_for_test_directory}
                      </DetailSpan>
                    </p> */}
                    <Link to="/dtrf-form">
                      <Button type="primary">Order Test</Button>
                    </Link>
                  </PatientCard>
                </Col>
              ))}
            </Row>
            <BlankSpace />
            <Xpagination
              style={{gap:"5px",flexWrap:"wrap"}}
              pageSizeOptions={["25", "50", "100", "500"]}
              showSizeChanger
              total={getTestBookListState.pagination?.total_records}
              onChange={(page, pageSize) =>
                setPagination({ page: page, records: pageSize })
              }
              current={pagination.page}
              defaultPageSize={pagination.records}
              showTotal={(total, range) =>
                `${range[0]}-${range[1]} of ${total} items`
              }
            />
          </>
        ) : (
          <div style={{ textAlign: "center" }}>
            <svg
              class="ant-empty-img-default"
              width="120"
              height="80"
              viewBox="0 0 184 152"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g fill="none" fill-rule="evenodd">
                <g transform="translate(24 31.67)">
                  <ellipse
                    class="ant-empty-img-default-ellipse"
                    cx="67.797"
                    cy="106.89"
                    rx="67.797"
                    ry="12.668"
                  ></ellipse>
                  <path
                    class="ant-empty-img-default-path-1"
                    d="M122.034 69.674L98.109 40.229c-1.148-1.386-2.826-2.225-4.593-2.225h-51.44c-1.766 0-3.444.839-4.592 2.225L13.56 69.674v15.383h108.475V69.674z"
                  ></path>
                  <path
                    class="ant-empty-img-default-path-2"
                    d="M101.537 86.214L80.63 61.102c-1.001-1.207-2.507-1.867-4.048-1.867H31.724c-1.54 0-3.047.66-4.048 1.867L6.769 86.214v13.792h94.768V86.214z"
                    transform="translate(13.56)"
                  ></path>
                  <path
                    class="ant-empty-img-default-path-3"
                    d="M33.83 0h67.933a4 4 0 0 1 4 4v93.344a4 4 0 0 1-4 4H33.83a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4z"
                  ></path>
                  <path
                    class="ant-empty-img-default-path-4"
                    d="M42.678 9.953h50.237a2 2 0 0 1 2 2V36.91a2 2 0 0 1-2 2H42.678a2 2 0 0 1-2-2V11.953a2 2 0 0 1 2-2zM42.94 49.767h49.713a2.262 2.262 0 1 1 0 4.524H42.94a2.262 2.262 0 0 1 0-4.524zM42.94 61.53h49.713a2.262 2.262 0 1 1 0 4.525H42.94a2.262 2.262 0 0 1 0-4.525zM121.813 105.032c-.775 3.071-3.497 5.36-6.735 5.36H20.515c-3.238 0-5.96-2.29-6.734-5.36a7.309 7.309 0 0 1-.222-1.79V69.675h26.318c2.907 0 5.25 2.448 5.25 5.42v.04c0 2.971 2.37 5.37 5.277 5.37h34.785c2.907 0 5.277-2.421 5.277-5.393V75.1c0-2.972 2.343-5.426 5.25-5.426h26.318v33.569c0 .617-.077 1.216-.221 1.789z"
                  ></path>
                </g>
              </g>
            </svg>
            <p>no data</p>
          </div>
        )}
        <div className="row">
          <div className="col-12 text-center mb-5">
            <Modal
              visible={isModalVisible}
              onOk={handleOk}
              onCancel={closeModal}
              footer={null}
            >
              <div className="row">
                <div className="col-12">
                  <div className="mb-4">
                    <h5 className="mb-2">Select Category For Test Directory</h5>
                    <Checkbox.Group
                      style={{
                        width: "100%",
                        marginLeft: 25,
                      }}
                      onChange={onChangeCat}
                    >
                      {getTestCategoriesState.apiState === "success" &&
                        getTestCategoriesState.list.map((doctor) => {
                          return (
                            <Checkbox
                              className="language-checkbox"
                              style={{ border: "none", padding: 5 }}
                              value={doctor.category_code}
                            >
                              {doctor.category_name}
                            </Checkbox>
                          );
                        })}
                      {/* {getCommonMasterListState.apiState === "success" &&
                        getCommonMasterListState.list[0]?.common_master_detail.map(
                          (doctor) => {
                            return (
                              <Checkbox
                                className="language-checkbox"
                                style={{ border: "none", padding: 5 }}
                                value={doctor.value}
                              >
                                {doctor.value}
                              </Checkbox>
                            );
                          }
                        )} */}
                    </Checkbox.Group>
                  </div>

                  <div className="col-12 text-center mt-3">
                    <Button type="primary" onClick={searchfiler}>
                      Filter
                    </Button>
                  </div>
                </div>
              </div>
            </Modal>
          </div>
        </div>
      </PageContainer>
    </>
  );
};

const mapStateToProps = (state) => ({
  getTestBookListState: state.getTestBookList,
  getCommonMasterListState: state.getCommonMasterList,
  getTestCategoriesState: state.getTestCategories,
});

const mapDispatchToProps = (dispatch) => ({
  getTestBookList: (params) => dispatch(getTestBookList(params)),
  getTestBookListResetState: () => dispatch(getTestBookListResetState()),
  getCommonMasterList: (params) => dispatch(getCommonMasterList(params)),
  getCommonMasterListReset: () => dispatch(getCommonMasterListReset()),
  getTestCategories: () => dispatch(getTestCategories()),
});

export default connect(mapStateToProps, mapDispatchToProps)(TestbookList);
